const wishWaitList = {
    openModalWindow: function (modal) {
        closeAllModal();
        $('body').append(modal);
    },

    buttonValue: function (element) {

        const data = {
            'type': element.attr('data-wishwaitlist'),
            'id': element.attr('data-id'),
            'lang': lang,
        }

        switch (data.type) {
            case 'wishlist':
                this.addToWishlist(data, element);
                break;

            case 'remove_wishlist':
                this.removeGoodWishlist(data, element);
                break;
        }
    },

    addToWishlist: function (dataObj, btn) {
        $.post(requests.addToWishlist, dataObj, function (data) {
            if (data.status == 'success') {
                $('.js__item_wishlist').empty().append(data.count_wishlist);
                btn.addClass('active');
                btn.attr('data-wishwaitlist', 'remove_wishlist');
            }
        });
    },

    removeGoodWishlist: function (dataObj, btn) {
        $.post(requests.removeGoodWishlist, dataObj, function (data) {
            if (data.status == 'success') {
                $('.js__item_wishlist').empty().append(data.count_wishlist);
                btn.removeClass('active');
                btn.attr('data-wishwaitlist', 'wishlist');
                if (btn.closest('.js_good_wishlist').length) {
                    btn.closest('.js_good_wishlist').remove()
                }
            }
        });
    },
};


$(document).ready(function () {
    $(document).on('click', '.js_good__wishlist', function () {
        wishWaitList.buttonValue($(this));
    });
});